import React, { Fragment } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import OverviewScreen from '../../../helperComponents/OverviewScreen';
import { GradientButton } from '../../../helperComponents/gradients/GradientButton';
import { FONT_STYLES, textStyles } from '../../../../constants/textStyles';
import { mbTextStyles } from '@mightybyte/rnw.utils.style-utils';
import PointsCard from '../../../helperComponents/PointsCard';
import CoinsIcon from '../../../../resources/svgComponents/CoinsIcon';

type PointsSummaryProps = {
    quarterNumber?: number;
    pointsAtCompletion?: number;
    referralPoints?: number;
    onPress?: () => void;
};

export default function PointsSummary({
    quarterNumber,
    pointsAtCompletion,
    referralPoints,
    onPress,
}: PointsSummaryProps) {
    const totalPoints = (referralPoints || 0) + (pointsAtCompletion || 0);

    return (
        <OverviewScreen
            topSectionStyle={styles.topSection}
            gradientColors={['#EF3A24', '#F9943B']}
            topSectionChildren={
                <Fragment>
                    <Text style={styles.topTitleText}>
                        QUARTER {quarterNumber}
                    </Text>
                    <Text style={styles.titleText}>POINTS SUMMARY</Text>
                    <View>
                        <CoinsIcon size={68} />
                    </View>
                </Fragment>
            }
            bottomSectionAnimated
        >
            <View style={styles.content}>
                <PointsCard
                    title="Points at completion"
                    points={pointsAtCompletion || 0}
                    backgroundColor="#F9EFFF"
                    textColor="#6A2C8C"
                />
                <View style={styles.plus}>
                    <Text style={styles.plusText}>+</Text>
                </View>
                <PointsCard
                    title="Referral bonus points"
                    points={referralPoints || 0}
                    backgroundColor="#FFF9F1"
                    textColor="#FCAF41"
                />
                <PointsCard
                    title="Total Points"
                    points={totalPoints}
                    backgroundColor="transparent"
                    textColor="#000000"
                    disableBorder
                    disableShadow
                />
                <GradientButton
                    title="VIEW RESULTS"
                    containerStyle={styles.btn}
                    onPress={onPress}
                />
            </View>
        </OverviewScreen>
    );
}

const styles = StyleSheet.create({
    topSection: {
        alignItems: 'center',
        justifyContent: 'center',
    },
    topTitleText: mbTextStyles([
        textStyles.largestText,
        {
            fontSize: 25,
            fontFamily: FONT_STYLES.Tabasco_400,
            color: '#FFFFFF',
            fontWeight: '400',
        },
    ]),
    titleText: mbTextStyles([
        textStyles.largestText,
        {
            fontSize: 38,
            fontFamily: FONT_STYLES.Tabasco_400,
            color: '#FFFFFF',
            fontWeight: '400',
            marginBottom: 20,
        },
    ]),
    content: {
        paddingHorizontal: 40,
        paddingBottom: 60,
        paddingTop: 20,
        flex: 1,
    },
    plus: {
        flexDirection: 'row',
        height: 1,
        zIndex: 2,
    },
    plusText: mbTextStyles([
        textStyles.largestText,
        {
            fontSize: 45,
            fontFamily: FONT_STYLES.Tabasco_400,
            color: '#F35E2E',
            fontWeight: '400',
            position: 'absolute',
            top: -37,
            right: 100,
        },
    ]),
    btn: {
        width: 227,
        alignSelf: 'center',
        marginTop: 'auto',
    },
});
